function replaceMenuItem(key, updateItems) {
    const res = {
        key,
        items: updateItems,
    };
    return res;
}
function findKeySchema(key, curSchema, updateItems) {
    const resSchema = curSchema.map((item) => {
        let cItem = item;
        if (typeof item === 'string') {
            if (item === key) {
                cItem = replaceMenuItem(key, updateItems);
            }
        }
        else {
            if (item.key === key) {
                cItem = replaceMenuItem(key, updateItems);
            }
            else {
                if (item.items) {
                    const tempItem = cItem;
                    if (typeof tempItem !== 'string') {
                        tempItem.items = findKeySchema(key, item.items, updateItems);
                    }
                    cItem = tempItem;
                }
            }
        }
        return cItem;
    });
    return resSchema;
}
/**
 * 查找 schema 配置表的子元素，修改子元素的内容，返回新的配置表
 *
 * @param key - 子元素 key
 * @param updateItems - 替换的配置元素
 */
function updateSchemaByKey(preSchema, key, updateItems) {
    const newSchema = findKeySchema(key, preSchema, updateItems);
    return newSchema;
}

export { updateSchemaByKey };
//# sourceMappingURL=util.js.map
